import 'vue-i18n';

let util = {};

util.tap = (function () {
    let _onStart, _onMove, _onEnd, _onCancel, _startPosX, _startPosY, _counter1, _counter2, _isTap,
        _supportTouch = !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);

    _onStart = function (e, active = '') {
        let point = e.changedTouches ? e.changedTouches[0] : e;

        _startPosX = point.pageX;
        _startPosY = point.pageY;
        _isTap = true;

        //避免触摸滑动时过早加上active样式
        _counter1 = setTimeout(() => {
            util.addClass(this, active);
        }, 30);

        //模拟长按
        _counter2 = setTimeout(() => {
            //不是一个tap事件
            _isTap = false;
            util.removeClass(this, active);
        }, 500);
    };

    _onMove = function (e, active) {
        let point = e.changedTouches ? e.changedTouches[0] : e,
            _currPosX = point.pageX,
            _currPosY = point.pageY;

        if (_currPosX - _startPosX > 10 || _currPosY - _startPosY > 10) {
            _counter1 && clearTimeout(_counter1);
            _counter2 && clearTimeout(_counter2);
            _isTap = false;
            util.removeClass(this, active);
        }
    };

    _onEnd = function (e, active) {
        let evt;

        _counter2 && clearTimeout(_counter2);
        setTimeout(() => {
            util.removeClass(this, active);
        }, 100);
        if (_isTap) {
            //evt = new UIEvent('tap', {bubbles: true, cancelable: true})
            evt = document.createEvent('UIEvent');
            evt.initEvent('tap', true, true);
            this.dispatchEvent(evt);
            _isTap = false;
        }
    };

    _onCancel = function (e, active) {
        _counter1 && clearTimeout(_counter1);
        _counter2 && clearTimeout(_counter2);
        _isTap = false;
        util.removeClass(this, active);
    };

    if (_supportTouch) {
        return function (pelm, elm, fn, active) {
            if (typeof elm === 'function') {
                active = fn;
                fn = elm;
                elm = pelm;
                pelm = false;
            }
            util.on('touchstart', pelm, elm, function (e) {
                _onStart.call(this, e, active);
            });
            util.on('touchmove', pelm, elm, function (e) {
                _onMove.call(this, e, active);
            });
            util.on('touchend', pelm, elm, function (e) {
                //prevent ghost click
                e.preventDefault();
                _onEnd.call(this, e, active);
            });
            util.on('touchcancel', pelm, elm, function (e) {
                _onCancel.call(this, e, active);
            });
            util.on('tap', pelm, elm, function (e) {
                if (typeof fn === 'function') {
                    fn.call(this, e);
                }
            });
            //fix bug in meizu mx5 oppo R9 android 5.1 browser
            util.on('touchstart', document, function() {});
        }
    } else {
        return function (pelm, elm, fn, active) {
            if (typeof elm === 'function') {
                active = fn;
                fn = elm;
                elm = pelm;
                pelm = false;
            }
            util.on('click', pelm, elm, function (e) {
                util.addClass(this, active);
                setTimeout(function () {
                    util.removeClass(this, active);
                }, 100);
                fn.call(this, e);
            });
        }
    }
})();

util.addClass = function (elm, kls) {
    if (kls && !util.hasClass(elm, kls)) {
        elm.className += ' ' + kls;
    }
};

util.removeClass = function (elm, kls) {
    let reg;

    if (kls && util.hasClass(elm, kls)) {
        reg = new RegExp(kls.trim(), 'g');
        elm.className = elm.className.replace(reg, '');
    }
};

util.hasClass = function (elm, kls) {
    let isMatch = false,
        classes;

    if (elm && elm.nodeType === Node.ELEMENT_NODE && kls) {
        classes = elm.className.split(' ');
        for (let i = 0; i < classes.length; i++) {
            if (classes[i] === kls) {
                isMatch = true;
                break;
            }
        }
        if (isMatch) return true
    }
    return false
};

util.remove = function (elm) {
    if (elm && elm.nodeType === Node.ELEMENT_NODE) {
        elm.parentNode && elm.parentNode.removeChild(elm);
    }
};

util.on = function (evt, ancestor, elm, fn) {
    if (typeof elm === 'function') {
        fn = elm;
        elm = ancestor;
        ancestor = false;
    }
    if (ancestor) {
        if (typeof ancestor === 'string') {
            ancestor = document.querySelectorAll(ancestor);
        } else {
            ancestor = [].concat(ancestor);
        }
        if (typeof elm === 'string') {
            elm = document.querySelectorAll(elm);
        } else {
            elm = [].concat(elm);
        }
        ancestor.forEach((ant, idx) => {
            ant.addEventListener(evt, function (e) {
                console.log(e.target);
                for (let i = elm.length - 1; i >= 0; i--) {
                    let parent = e.target.parentNode, el = elm[i];

                    if (e.target === el) {
                        //此处event的currentTarget尚有问题，并且无preventDefault
                        fn && fn.call(el, e);
                        continue
                    }
                    while (parent && parent !== ant) {
                        if (parent === el) {
                            //此处event的currentTarget尚有问题，并且无preventDefault
                            fn && fn.call(el, e);
                            break
                        }
                        parent = parent.parentNode;
                    }
                }
            }, false);
        });
    } else {
        if (typeof elm === 'string') {
            elm = document.querySelectorAll(elm);
        } else {
            elm = [].concat(elm);
        }
        elm.forEach((el, idx) => {
            el.addEventListener(evt, function (e) {
                fn && fn.call(this, e);
            }, false);
        });
    }
};

//所有动效接口都需要实现show和hide方法

let Animations;
let NoneAnimation = {
  show: false,
  hide: false
};

//pop动效
let PopAnimation = {
  //参数cb为动效完成后的回调
  show(cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-show');
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show');
      if(typeof cb === 'function') cb();
    });
    this.wrap.addEventListener('animationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show');
      if(typeof cb === 'function') cb();
    });
  },
  hide(cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-hide');
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.remove(this.container);
      if(typeof cb === 'function') cb();
    });
    this.wrap.addEventListener('animationEnd', () => {
      util.remove(this.container);
      if(typeof cb === 'function') cb();
    });
  }
};

// slide动效，for tips
let SlideAnimation = {
  show: function(cb) {
    //
    setTimeout(() => {
      util.addClass(this.content, 'didi-dialog-slide-show');
    }, 20);
    setTimeout(() => {
      util.removeClass(this.content, 'didi-dialog-slide-show');
      this.wrap.addEventListener('webkitTransitionEnd', () => {
        util.remove(this.container);
        if(typeof cb === 'function') cb();
      });
    }, this.cfg.timeout || 2000);
  },
  hide: function(cb) {
    //do nothing
  }
};

Animations = {
  none: NoneAnimation,
  pop: PopAnimation,
  slide: SlideAnimation
};

var Animations$1 = Animations;

// import {resolveQuery} from '../../tool'

let obj = {}, // resolveQuery(location.href),
    lang$1 = (obj.lang || 'pt-BR').toLowerCase();


var translation = {
    'pt-br': {
        'confirm': 'Confirmar',
        'cancel': 'Cancelar',
        'gotit': 'Entendi'
    },
    'en-us': {
        'confirm': 'confirm',
        'cancel': 'cancel',
        'gotit': 'Got it'
    },
    'zh-cn': {
        'confirm': '确认',
        'cancel': '取消',
        'gotit': '我知道了'
    }
};

function t(key) {
    if(translation[lang$1]) {
        return translation[lang$1][key] || key
    }

    return key
}

let Components = {}, dd = {};

class Dialog {
    constructor(cfg) {
        let container = document.createElement('div'),
            wall = '<div id="d-wall" class="didi-dialog-wall"></div>',
            wrap =
                '<div id="d-wrap" class="didi-dialog-wrap">' +
                '<div id="d-content" class="didi-dialog-content">' +
                '</div>' +
                '</div>';

        container.setAttribute('id', 'd-container');
        container.setAttribute('class', 'didi-dialog-container');
        container.innerHTML = wall + wrap;

        this.cfg = cfg;
        this.container = container;
        this.wall = container.querySelector('#d-wall');
        this.wrap = container.querySelector('#d-wrap');
        this.content = container.querySelector('#d-content');
        this.addParts();
    }

    addParts() {
        //可以为dialog增加一个特殊标志属性，以便根据该属性来控制样式
        if (this.cfg.tag) {
            this.container.setAttribute(this.cfg.tag, '');
        }
        if (this.cfg.icon !== false) {
            this.addIcon();
        }
        if (this.cfg.title) {
            this.addTitle();
        }
        if (this.cfg.desc) {
            this.addDesc();
        }
        if (this.cfg.btns !== false) {
            this.addButts();
        }
    }

    addIcon() {
        let icon = '<div class="didi-dialog-icon">', img;

        if (this.cfg.icon === false) {
            return false
        } else if (typeof this.cfg.icon === 'string' && this.cfg.icon.match(/^https?:/)) {
            //url方式
            img = '<img src="' + this.cfg.icon + '"/>';
            icon += img;
        } else if (typeof this.cfg.icon === 'string') {
            //标签方式
            icon += this.cfg.icon;
        } else ;
        icon += '</div>';
        this.content.innerHTML += icon;
    }

    addTitle() {
        let title = '<div class="didi-dialog-title">';

        if (!this.cfg.title) {
            return false
        } else if (typeof this.cfg.title === 'string') {
            title += this.cfg.title;
        }
        title += '</div>';
        this.content.innerHTML += title;
    }

    addDesc() {
        let desc = '<div class="didi-dialog-desc">';

        if (!this.cfg.desc) {
            return false
        } else if (typeof this.cfg.desc === 'string') {
            desc += this.cfg.desc;
        }
        desc += '</div>';
        this.content.innerHTML += desc;
    }

    addButts() {
        let btns = this.cfg.btns, butts;

        if (Array.isArray(btns) && btns.length > 0) {
            butts = document.createElement('div');
            butts.setAttribute('class', 'didi-dialog-butts');
            btns.forEach(function (btn, idx) {
                let butt = document.createElement('div');
                btn.id && butt.setAttribute('id', btn.id);
                btn.kls && butt.setAttribute('class', btn.kls);
                butt.innerHTML = btn.text || '';
                butts.appendChild(butt);
                if (typeof btn.callback === 'function') {
                    util.tap(butt, function (e) {
                        //this指向butt
                        btn.callback.call(this, e);
                    }, 'active');
                }
            });
            this.content.appendChild(butts);
        }
    }

    show(animate, cb) {
        document.body.appendChild(this.container);

        if (animate && typeof animate.show === 'function') {
            animate.show.call(this, cb);
        }
    }

    hide(animate, cb) {
        if (animate && typeof animate.hide === 'function') {
            animate.hide.call(this, cb);
        } else {
            setTimeout(() => {
                util.remove(this.container);
            }, 100);
        }
    }
}

//每个组件单独实现，更好单独控制
//alert
Components.alert = function (opt = {}) {
    let cfg, alertObj, animate;

    cfg = {
        desc: opt.desc,
        title: opt.title,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout,
        btns: opt.btns || [{
            id: 'd-btn-ok',
            kls: 'didi-dialog-btn-ok',
            text: opt.text || t('gotit'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                alertObj.hide(animate);
                //Fusion.closePage();
                typeof opt.callback === 'function' && opt.callback.call(this, e);
            }
        }]
    };

    alertObj = new Dialog(cfg);
    animate = Animations$1[alertObj.cfg.animateType];
    alertObj.container.setAttribute('dialog-type', 'alert');
    alertObj.show(animate);

    //自动关闭
    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            alertObj.hide(animate);
        }, cfg.timeout);
    }

    return alertObj
};

//confirm
Components.confirm = function (opt = {}) {
    let cfg, confirmObj, animate;

    cfg = {
        title: opt.title,
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon === undefined ? true : opt.icon,
        timeout: opt.timeout,
        btns: opt.btns || [{
            id: 'd-btn-ok',
            kls: 'didi-dialog-btn-ok',
            text: opt.confirmText || t('confirm'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                confirmObj.hide(animate);
                typeof opt.confirmCallback === 'function' && opt.confirmCallback.call(this, e);
            }
        },{
            id: 'd-btn-cancel',
            kls: 'didi-dialog-btn-cancel',
            text: opt.cancelText || t('cancel'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                confirmObj.hide(animate);
                typeof opt.cancelCallback === 'function' && opt.cancelCallback.call(this, e);
            }
        } ]
    };

    confirmObj = new Dialog(cfg);
    animate = Animations$1[confirmObj.cfg.animateType];
    confirmObj.container.setAttribute('dialog-type', 'confirm');
    confirmObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            confirmObj.hide(animate);
        }, cfg.timeout);
    }
    
    return confirmObj
};

//loading
Components.loading = function (opt = {}) {
    let cfg, loadingObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    loadingObj = new Dialog(cfg);
    animate = Animations$1[loadingObj.cfg.animateType];
    loadingObj.container.setAttribute('dialog-type', 'loading');
    loadingObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            //loading完之后如果需要可回调
            if (typeof cfg.after === 'function') {
                loadingObj.hide(animate, cfg.after);
            } else {
                loadingObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return loadingObj
};

//success
Components.success = function (opt = {}) {
    let cfg, succObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    succObj = new Dialog(cfg);
    animate = Animations$1[succObj.cfg.animateType];
    succObj.container.setAttribute('dialog-type', 'success');
    succObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                succObj.hide(animate, cfg.after);
            } else {
                succObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return succObj
};

//warn
Components.warn = function (opt = {}) {
    let cfg, warnObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    warnObj = new Dialog(cfg);
    animate = Animations$1[warnObj.cfg.animateType];
    warnObj.container.setAttribute('dialog-type', 'warn');
    warnObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                warnObj.hide(animate, cfg.after);
            } else {
                warnObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return warnObj
};

Components.tips = function (opt = {}) {
    let cfg, tipsObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'slide',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    tipsObj = new Dialog(cfg);
    animate = Animations$1[tipsObj.cfg.animateType];
    tipsObj.container.setAttribute('dialog-type', 'tips');
    tipsObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                tipsObj.hide(animate, cfg.after);
            } else {
                tipsObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return tipsObj
};

let c;
for(let i in Components) {
    dd[i] = function(...params) {
        c && c.hide();
        if(params[0] !== false) {
            c = Components[i].apply(null, arguments);
        }
    };
}
window.dd = dd;

// const ends = {

function imgCompress(dom, callback, errorCallback) {
  if (!dom)
    return
  const MAX_SIZE = 8 * 1024 * 1024;
  let FILE_SIZE = 0;
  dom.onchange = function () {
    const rate = 1;
    let file = dom.files[0];
    if (file.size > MAX_SIZE) {
      errorCallback && errorCallback();
      return
    }
    FILE_SIZE = file.size;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      let url = e.target.result;
      let img = new Image;
      img.src = url;
      img.onload = function () {
        let imgWidth = img.width;
        let imgHeight = img.height;
        let imgRate = (imgWidth < imgHeight ?
          imgWidth / imgHeight :
          imgHeight / imgWidth) / rate;
        canvas.width = imgWidth * imgRate;
        canvas.height = imgHeight * imgRate;
        // ctx.translate(imgWidth * imgRate, imgHeight * imgRate);
        // ctx.rotate(Math.PI)

        // let userAgent = navigator.userAgent.toLowerCase();
        // let andVar = userAgent.match(/sm-/i);

        // ios系统是否小于13.4
        let isRotate = true;
        // @20201230 解决图片旋转的方法一：判断机型（判断情况太多，所以使用方法二）
        // if (ends.isIOS) {
        //   let iosVer = getIosVerStr();
        //   isRotate = isVerLessThan(iosVer, '13.4');
        // }
        // if (isSamsung()) {
        //   let androidVerStr = getAndroidVerStr();
        //   isRotate = isVerLessThan(androidVerStr, '9');
        // }

        // @20201230 解决图片旋转的方法一：检查浏览器是否支持自动图像定向
        if (window.browserImgRotate) {
          isRotate = false;
        }

        if (isRotate) {
          let o = _getFileOrientation(_base64ToArrayBuffer(url));
          if (o == 6) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.rotate(90 / 180 * Math.PI);
            ctx.translate(0, -imgHeight * imgRate);
          } else if (o == 8) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.translate(0, imgWidth * imgRate);
            ctx.rotate(270 / 180 * Math.PI);
          } else if (o == 3) {
            canvas.width = imgHeight * imgRate;
            canvas.height = imgWidth * imgRate;
            ctx.translate(imgWidth * imgRate, imgHeight * imgRate);
            ctx.rotate(180 / 180 * Math.PI);
          }
        }

        ctx.drawImage(img, 0, 0, imgWidth, imgHeight, 0, 0, imgWidth *
          imgRate, imgHeight * imgRate);
        let imgUrl = canvas.toDataURL('image/jpeg');
        canvas = null;
        callback && callback.call(this, {
          image: imgUrl,
          errorCode: 104,
          originSize: FILE_SIZE
        });
      };
    };
  };
}
/* 获取拍照时照片的方向，可根据方向对图片展示时进行相应旋转操作，保证图片0度显示
  返回值----------------    1    0°
                           6    顺时针90°
                           8    逆时针90°
                           3    180°
*/
function _getFileOrientation(arrayBuffer) {
  var view = new DataView(arrayBuffer);
  if (view.getUint16(0, false) != 0xFFD8) return -2
  var length = view.byteLength;
  var offset = 2;
  while (offset < length) {
    var marker = view.getUint16(offset, false);
    offset += 2;
    if (marker == 0xFFE1) {
      if (view.getUint32(offset += 2, false) != 0x45786966) return -1
      var little = view.getUint16(offset += 6, false) == 0x4949;
      offset += view.getUint32(offset + 4, little);
      var tags = view.getUint16(offset, little);
      offset += 2;
      for (var i = 0; i < tags; i++) {
        if (view.getUint16(offset + (i * 12), little) == 0x0112) {
          return view.getUint16(offset + (i * 12) + 8, little)
        }
      }
    } else if ((marker & 0xFF00) != 0xFF00) break
    else offset += view.getUint16(offset, false);
  }
  return -1
}

function _base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data:([^;]+);base64,/gmi, '');
  var binaryString = atob(base64);
  var len = binaryString.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer
}

const SOURCE = {
  web: '',
  fleetApp: 'com.app99.fleet',
  fleet: 'com.didiglobal.fleet',
  global: 'com.didiglobal.driver',
  globalIos: 'com.didi.global.driver',
  br_99: 'com.app99.driver',
  global_au: 'com.didiglobal.driver.au',
  minibus_new: 'com.didiglobal.bus',
  minibus_old: 'com.didiglobal.driver.bus',
};
//通过判断操作系统判断PC端
const XulgrPlatformisPC = () => {
  var system = {
    win: false,
    mac: false,
    xll: false,
  };
  var p = navigator.platform;
  system.win = p.indexOf("Win") == 0;
  system.mac = p.indexOf("Mac") == 0;
  system.x11 = p == "X11" || p.indexOf("Linux") == 0;
  return system.win || system.mac || system.xll ? true : false;
};

const up = new URLSearchParams(location.search);
const ends = {
  isIOS: /(iPhone|iPad|iPod|iOS)/i.test (navigator.userAgent),
  isAndroid: /(Android)/i.test (navigator.userAgent),
  isPC: up.get ('from') === 'official_site',
  isPlatformPC: XulgrPlatformisPC()
};

function getEnd() {
  let up = new URLSearchParams(location.search);
  const bundle_id = up.get('bundle_id') || "";
  const fleet_register_pc = up.get('fleet_register_pc');
  const from_fleetPC = up.get('from_fleetPC');
  const from_fleetAPP = up.get('from_fleetAPP');
  let end = "WebEnd"; // 手机浏览器
  if (bundle_id.indexOf(SOURCE.fleetApp) > -1) {
    end = "FleetAppEnd"; // Fleet APP 巴西
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && (fleet_register_pc == 1 || from_fleetPC == 1)) {
    end = "FleetPCEnd"; // Fleet PC
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && from_fleetAPP == 1) {
    end = "FleetEnd"; // Fleet APP 墨西哥
  } else if (bundle_id.indexOf(SOURCE.global) > -1) {
    end = "DriverEnd"; // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.br_99) > -1) {
    end = "DriverEnd"; // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.globalIos) > -1) {
    end = 'DriverEnd'; // 手机司机端(ios)
  } else if (bundle_id.indexOf(SOURCE.minibus_new) > -1 || bundle_id.indexOf(SOURCE.minibus_old) > -1) {
    end = 'DriverEnd'; // 小巴司机端
  } else if ((ends.isIOS && (up.get('datatype') == 101)) ||
    (ends.isAndroid && (up.get('datatype') == 1))) {
    //乘客端
    end = "PassengerEnd";
  } else if (ends.isPC) {
    //官方网站
    end = "PCEnd";
  }
  return end
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 前端h5页面用
var _info = {};

function i18nInit(info) {
  _info = info;
}

function i18nGet(langText, langType) {
  try {
    if (/^ar/.test((langType || "").toLowerCase())) {
      window.i18nArabicRTL = true;
      document.body.setAttribute("class", "".concat((document.body.getAttribute("class") || "").replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
    }

    if (!window.i18nPluginH5DiffCopywriter || !langType) {
      return langText;
    }

    var langDiff = window.i18nPluginH5DiffCopywriter[langType.toLowerCase().replace("-", "_")];
    if (!langDiff) return langText;
    Object.keys(langDiff).forEach(function (key) {
      if (_info.prefix && new RegExp(_info.prefix).test(key)) {
        langDiff[key.replace(_info.prefix, "")] = langDiff[key];
        delete langDiff[key];
      }
    });

    var walk = function walk(obj, keyStr, value) {
      var keyArr = _info.noParse ? [keyStr] : keyStr.split(".");

      if (keyArr.length === 1) {
        Object.assign(obj, _defineProperty({}, keyStr, value === "[]" ? [] : value));
      } else {
        if (!obj[keyArr[0]]) obj[keyArr[0]] = {};
        Object.assign(obj[keyArr[0]], walk(obj[keyArr[0]], keyArr.slice(1).join("."), value));
      }

      return obj;
    };

    Object.keys(langDiff).map(function (keyStr) {
      walk(langText, keyStr, langDiff[keyStr]);
    });
  } catch (e) {
    console.log('i18n-plugin-error:', e);
  }

  return langText;
}
var i18nInit_1 = i18nInit;
var i18nGet_1 = i18nGet;

var i18nInfo = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-global-fe-Growth-driver-page",
  "filePath": "/packages/headimg-audit/src/locales",
  "version": 588,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-Growth-driver-page/packages/headimg-audit/src/locales/all.js",
  "noParse": false,
  "noOmega": false
};

var GDriver_optimization_zvhB_cjIq$7 = "Submit";
var GDriver_optimization_tDnq_eESD$7 = "Unable to recognize your face. Please try again";
var GDriver_optimization_BUsm_LKQr$7 = "Optimizing";
var GDriver_optimization_EjyT_xpZO$7 = "Photo recognition";
var GDriver_optimization_UHSS_rMoK$7 = "Recognition Failed";
var GDriver_optimization_SVLQ_jiyW$7 = "Optimization Completed";
var GDriver_optimization_OekV_nGpZ$7 = "Next";
var GDriver_optimization_eUOa_wjcw$7 = "Photo color vibrancy";
var GDriver_optimization_vEiW_Qiqr$7 = "Look directly at the camera and ensure your entire face is visible";
var GDriver_picture_Line_box_OsdL$7 = "Ensure your entire face is inside the dotted line";
var GDriver_optimization_UAgg_aeEM$7 = "Image cropping";
var GDriver_optimization_LYku_iJnP$7 = "Possibility of approval";
var GDriver_optimization_NtzF_ctdc$7 = "Background Adjustment";
var GDriver_optimization_BBFP_lTCB$7 = "Reupload";
var GDriver_optimization_BDHr_UnLn$7 = "Use this photo?";
var GDriver_picture_View_frame_usSJ$7 = "To ensure fast approval, please use two fingers to move the photo to make sure your entire face is pictured";
var GDriver_optimization_qhaw_wHWp$7 = "Back";
var GDriver_optimization_cXei_rJTN$7 = "System error. Please try again";
var GDriver_optimization_myDn_DSEM$7 = "For faster approval, please make sure the photo is of you. Once confirmed, tap Next, and we’ll help you optimize your profile photo";
var enUS = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$7,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$7,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$7,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$7,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$7,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$7,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$7,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$7,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$7,
	"register---图片尺寸过大": "Your upload must be less than 8MB, please try again.",
	"register---提交": "Next",
	"register---取消": "Cancel",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$7,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$7,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$7,
	"document-expired---返回": "Back",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$7,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$7,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$7,
	"register---确认": "OK",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$7,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$7,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$7,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$7
};

var GDriver_optimization_zvhB_cjIq$6 = "Enviar";
var GDriver_optimization_tDnq_eESD$6 = "Não foi possível reconhecer seu rosto. Por favor, tente novamente";
var GDriver_optimization_BUsm_LKQr$6 = "Otimizando";
var GDriver_optimization_EjyT_xpZO$6 = "Reconhecer foto";
var GDriver_optimization_UHSS_rMoK$6 = "Erro no reconhecimento";
var GDriver_optimization_SVLQ_jiyW$6 = "Otimização concluída";
var GDriver_optimization_OekV_nGpZ$6 = "Avançar";
var GDriver_optimization_eUOa_wjcw$6 = "Cor da foto";
var GDriver_optimization_vEiW_Qiqr$6 = "Olhe diretamente para a câmera e enquadre todo seu rosto";
var GDriver_picture_Line_box_OsdL$6 = "Certifique-se que todo o seu rosto esteja dentro da linha pontilhada";
var GDriver_optimization_UAgg_aeEM$6 = "Cortar a imagem";
var GDriver_optimization_LYku_iJnP$6 = "Possibilidade de aprovação";
var GDriver_optimization_NtzF_ctdc$6 = "Ajustar o fundo";
var GDriver_optimization_BBFP_lTCB$6 = "Reenviar";
var GDriver_optimization_BDHr_UnLn$6 = "Usar esta foto?";
var GDriver_picture_View_frame_usSJ$6 = "Para uma aprovação rápida, use dois dedos para mover a foto e garantir que todo o seu rosto seja enquadrado";
var GDriver_optimization_qhaw_wHWp$6 = "Voltar";
var GDriver_optimization_cXei_rJTN$6 = "Erro no sistema. Tente novamente";
var GDriver_optimization_myDn_DSEM$6 = "Para uma aprovação mais rápida, certifique-se de que a foto é sua. Após a confirmação, toque em Avançar e ajudaremos você a otimizar a foto de perfil";
var ptBR = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$6,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$6,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$6,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$6,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$6,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$6,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$6,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$6,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$6,
	"register---图片尺寸过大": "O tamanho da imagem é muito grande, por favor envie novamente",
	"register---提交": "Avançar",
	"register---取消": "Corrigir",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$6,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$6,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$6,
	"document-expired---返回": "Retorno",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$6,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$6,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$6,
	"register---确认": "Avançar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$6,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$6,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$6,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$6
};

var GDriver_optimization_zvhB_cjIq$5 = "Enviar";
var GDriver_optimization_tDnq_eESD$5 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$5 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$5 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$5 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$5 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$5 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$5 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$5 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$5 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$5 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$5 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$5 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$5 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$5 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$5 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$5 = "Volver";
var GDriver_optimization_cXei_rJTN$5 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$5 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var esMX = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$5,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$5,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$5,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$5,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$5,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$5,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$5,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$5,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$5,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$5,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$5,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$5,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$5,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$5,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$5,
	"register---确认": "Enviar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$5,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$5,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$5,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$5
};

var GDriver_optimization_zvhB_cjIq$4 = "Enviar";
var GDriver_optimization_tDnq_eESD$4 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$4 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$4 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$4 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$4 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$4 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$4 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$4 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$4 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$4 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$4 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$4 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$4 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$4 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$4 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$4 = "Atrás";
var GDriver_optimization_cXei_rJTN$4 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$4 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var esCO = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$4,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$4,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$4,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$4,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$4,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$4,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$4,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$4,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$4,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$4,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$4,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$4,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$4,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$4,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$4,
	"register---确认": "Aceptar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$4,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$4,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$4,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$4
};

var GDriver_optimization_zvhB_cjIq$3 = "Enviar";
var GDriver_optimization_tDnq_eESD$3 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$3 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$3 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$3 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$3 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$3 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$3 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$3 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$3 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$3 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$3 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$3 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$3 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$3 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$3 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$3 = "Volver";
var GDriver_optimization_cXei_rJTN$3 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$3 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var es419 = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$3,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$3,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$3,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$3,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$3,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$3,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$3,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$3,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$3,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$3,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$3,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$3,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$3,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$3,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$3,
	"register---确认": "Aceptar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$3,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$3,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$3,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$3
};

var GDriver_optimization_zvhB_cjIq$2 = "Submit";
var GDriver_optimization_tDnq_eESD$2 = "Unable to recognise your face. Please try again";
var GDriver_optimization_BUsm_LKQr$2 = "Optimising...";
var GDriver_optimization_EjyT_xpZO$2 = "Photo Recognition";
var GDriver_optimization_UHSS_rMoK$2 = "Recognition Failed";
var GDriver_optimization_SVLQ_jiyW$2 = "Optimisation Completed";
var GDriver_optimization_OekV_nGpZ$2 = "Next";
var GDriver_optimization_eUOa_wjcw$2 = "Background colour vibrancy";
var GDriver_optimization_vEiW_Qiqr$2 = "Look directly at the camera and ensure your full face is visible";
var GDriver_picture_Line_box_OsdL$2 = "Ensure your entire face is inside the dotted line";
var GDriver_optimization_UAgg_aeEM$2 = "Image Cropping";
var GDriver_optimization_LYku_iJnP$2 = "Possibility of approval";
var GDriver_optimization_NtzF_ctdc$2 = "Background Adjustment";
var GDriver_optimization_BBFP_lTCB$2 = "Upload Again";
var GDriver_optimization_BDHr_UnLn$2 = "Do you want to use this photo?";
var GDriver_picture_View_frame_usSJ$2 = "To ensure fast approval, please use two fingers to move the photo to make sure your entire face is pictured";
var GDriver_optimization_qhaw_wHWp$2 = "Back";
var GDriver_optimization_cXei_rJTN$2 = "System error. Please try again";
var GDriver_optimization_myDn_DSEM$2 = "For faster approval, please make sure the photo is of you. Once confirmed, tap Next, and we’ll help you optimise your profile photo";
var esAU = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$2,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$2,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$2,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$2,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$2,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$2,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$2,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$2,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$2,
	"register---图片尺寸过大": "Your upload must be less than 8MB, please try again.",
	"register---提交": "Next",
	"register---取消": "Cancel",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$2,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$2,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$2,
	"document-expired---返回": "Back",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$2,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$2,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$2,
	"register---确认": "OK",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$2,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$2,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$2,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$2
};

var GDriver_optimization_zvhB_cjIq$1 = "送信";
var GDriver_optimization_tDnq_eESD$1 = "顔認証ができませんでした。もう一度お試しください";
var GDriver_optimization_BUsm_LKQr$1 = "画像処理中";
var GDriver_optimization_EjyT_xpZO$1 = "画像識別";
var GDriver_optimization_UHSS_rMoK$1 = "認証失敗";
var GDriver_optimization_SVLQ_jiyW$1 = "最適化完了";
var GDriver_optimization_OekV_nGpZ$1 = "次へ";
var GDriver_optimization_eUOa_wjcw$1 = "画像の明るさ";
var GDriver_optimization_vEiW_Qiqr$1 = "カメラをまっすぐ見て顔全体が写るようにしてください";
var GDriver_picture_Line_box_OsdL$1 = "点線の中に顔全体が入るようにしてください";
var GDriver_optimization_UAgg_aeEM$1 = "トリミング";
var GDriver_optimization_LYku_iJnP$1 = "画像承認率";
var GDriver_optimization_NtzF_ctdc$1 = "背景調整";
var GDriver_optimization_BBFP_lTCB$1 = "再アップロード";
var GDriver_optimization_BDHr_UnLn$1 = "この写真を使用しますか？";
var GDriver_picture_View_frame_usSJ$1 = "スムーズな承認のため、2つの指で写真を移動し、顔全体が写っているようにしてください";
var GDriver_optimization_qhaw_wHWp$1 = "戻る";
var GDriver_optimization_cXei_rJTN$1 = "システムエラー。再試行してください";
var GDriver_optimization_myDn_DSEM$1 = "ご自身が写っているか確認いただき、問題なければ「次へ」をタップしてください。プロフィール写真の最適化を実行いたします";
var jaJP = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$1,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$1,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$1,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$1,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$1,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$1,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$1,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$1,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$1,
	"register---图片尺寸过大": "アップロードできるファイルは8MB未満です。再試行してください。",
	"register---提交": "次へ",
	"register---取消": "キャンセル",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$1,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$1,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$1,
	"document-expired---返回": "戻る",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$1,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$1,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$1,
	"register---确认": "OK",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$1,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$1,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$1,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$1
};

var GDriver_optimization_zvhB_cjIq = "إرسال";
var GDriver_optimization_tDnq_eESD = "تعذّر التعرُّف على وجهك. يُرجى المحاولة مرة أخرى";
var GDriver_optimization_BUsm_LKQr = "جارٍ التحسين";
var GDriver_optimization_EjyT_xpZO = "التعرُّف على الصورة";
var GDriver_optimization_UHSS_rMoK = "تعذّر التعرُّف";
var GDriver_optimization_SVLQ_jiyW = "اكتمل التحسين";
var GDriver_optimization_OekV_nGpZ = "التالي";
var GDriver_optimization_eUOa_wjcw = "سطوع ألوان الصورة";
var GDriver_optimization_vEiW_Qiqr = "انظر إلى الكاميرا مباشرةً وتأكد من ظهور وجهك بالكامل";
var GDriver_picture_Line_box_OsdL = "تأكد من أن وجهك بالكامل داخل الخط المنقط";
var GDriver_optimization_UAgg_aeEM = "قص الصورة";
var GDriver_optimization_LYku_iJnP = "احتمالية الموافقة";
var GDriver_optimization_NtzF_ctdc = "تعديل الخلفية";
var GDriver_optimization_BBFP_lTCB = "إعادة تحميل";
var GDriver_optimization_BDHr_UnLn = "هل تريد استخدام هذه الصورة؟";
var GDriver_picture_View_frame_usSJ = "لضمان سرعة الموافقة، يُرجى استخدام أصبعين لتحريك الصورة والتأكد من أن وجهك ظاهر بالكامل";
var GDriver_optimization_qhaw_wHWp = "رجوع";
var GDriver_optimization_cXei_rJTN = "خطأ في النظام، أعِد المحاولة";
var GDriver_optimization_myDn_DSEM = "للحصول على الموافقة بسرعة أكبر، يُرجى التأكد من أن الصورة هي صورتك. بمجرد التأكد، اضغط على \"التالي\"، وسنُساعدك على تحسين صورتك التعريفية.";
var arEG = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr,
	"register---图片尺寸过大": "يجب أن لا يتجاوز حجم التحميل 8 ميجابايت. أعِد المحاولة.",
	"register---提交": "التالي",
	"register---取消": "إلغاء",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP,
	"document-expired---返回": "رجوع",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn,
	"register---确认": "موافق",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM
};

i18nInit_1 (i18nInfo);

let lang = new URLSearchParams (location.search).get ('lang');
const i18n = {
  locale: lang || 'en-US',
  fallbackLocale:'default',
  messages: {
    'pt-BR': i18nGet_1 (ptBR, 'pt-br'),
    'es-MX': i18nGet_1 (esMX, 'es-mx'),
    'es-CO': i18nGet_1 (esCO, 'es-co'),
    'en-AU': i18nGet_1 (esAU, 'en-au'),
    'es-419': i18nGet_1 (es419, 'es-419'),
    'ja-JP': i18nGet_1 (jaJP, 'ja-JP'),
    'ar-EG': arEG,
    default: i18nGet_1 (enUS, lang),
  },
};

const AUDIT_STATUS = {
  in: 3,
  success: 4,
  fail: 5,
  noSubmit: 0,
  beforeUpdate: 6,
};

const Fusion = window.Fusion;

var avatarNew = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isViewAudit)?_c('div',{staticClass:"avatar-head-image",class:{ upload: _vm.isUpload }},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.pics[0]}})]),_vm._v(" "),_c('div',{staticClass:"photo-suggest"},[_c('h3',{staticClass:"suggest-title"},[_vm._v(_vm._s(_vm.pic_desc.title))]),_vm._v(" "),_vm._l((_vm.pic_desc.content),function(item,idx){return _c('p',{key:idx,staticClass:"suggest-desc",domProps:{"innerHTML":_vm._s(item)}})}),_vm._v(" "),_c('div',{class:['sample-image-list']},_vm._l((_vm.error_cases.cases),function(item,idx){return _c('div',{key:idx,staticClass:"sample-item"},[_c('img',{attrs:{"src":item.img_url,"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.desc))])])}),0)],2),_vm._v(" "),_c('div',{staticClass:"upload-photo-btn-wrap dim-button-wrapper"},[_c('div',{staticClass:"upload-photo-btn dim-button dim-button-block",class:[_vm.location_country == 'BR'?'dim-button-yellow': 'dim-button-orange'],on:{"click":_vm.uploadBtnClick}},[(_vm.inApp)?[_c('input',{attrs:{"type":"button"},on:{"click":_vm.uploadImg}}),_vm._v("\n        "+_vm._s(_vm.isNew ? _vm.uploadBtn.un_check.title : _vm.uploadBtn.is_check.title)+"\n      ")]:[(_vm.headImgConfig.limit_status)?_c('input',{attrs:{"id":"photo","type":"file","accept":"image/*","capture":"camera"}}):_c('input',{attrs:{"id":"photo","type":"file","accept":"image/*"}}),_vm._v("\n        "+_vm._s(_vm.isNew ? _vm.uploadBtn.un_check.title : _vm.uploadBtn.is_check.title)+"\n      ")]],2)])]):_c('div',{class:['reUpload-avatar-head-image']},[(_vm.headImgConfig.field_result)?_c('div',{class:[
      'status-tips',
      {
        success: _vm.field_status == _vm.AUDIT_STATUS.success,
        checking:
          _vm.field_status == _vm.AUDIT_STATUS.in ||
          _vm.field_status == _vm.AUDIT_STATUS.noSubmit,
        error: _vm.field_status == _vm.AUDIT_STATUS.fail,
      } ]},[_c('div',[_vm._v(_vm._s(_vm.headImgConfig.field_result))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.uploadImgSrc}})]),_vm._v(" "),(_vm.field_status == 4 ? _vm.headImgConfig.re_upload : true)?_c('div',{staticClass:"reUpload-btn-wrap dim-button-wrapper"},[_c('div',{staticClass:"reUpload-btn dim-button dim-button-block dim-button-default",on:{"click":_vm.reUploadImg}},[_vm._v("\n      "+_vm._s(_vm.resetBtn.un_check.title)+"\n    ")])]):_vm._e()])},
staticRenderFns: [],
  name: "headImage",
  props: ["auditConfig"],
  i18n: i18n,
  data() {
    return {
      AUDIT_STATUS,
      useRTL: window.i18nArabicRTL,
      // photoSrc: require("img!../images/sample_big.png"),
      isUpload: false,
      headStatus: 0,
      uploadImgSrc: "",
      isViewAudit: false, // 是不是证件上传完后的查看状态
      isTakePhoto: false, // 用户是从相册上传还是拍照上传
    };
  },
  created() {
    //非nosubmit，展示上传区域、传过的图片
    // console.log("this.isNew", this.isNew);
    if (!this.isNew) {
      this.isViewAudit = true;
      this.uploadImgSrc = this.headImgConfig.value[0] || "";
    } else {
      this.isViewAudit = false;
      this.uploadImgSrc = "";
      try {
        Omega.trackEvent("ibt_global_portrait_takephoto_sw", "", {
          ...this.omegaItems,
        });
      } catch (error) {}
    }
  },
  mounted() {
    this.initOutUpload();
  },
  watch: {
    isViewAudit(newVal) {
      if (!newVal) {
        //查看态切回重新选择的页面时，再次赋值(因为查看态是没有"photo"这个input元素的)
        this.$nextTick(() => this.initOutUpload());
        try {
          Omega.trackEvent("ibt_global_portrait_takephoto_sw", "", {
            ...this.omegaItems,
          });
        } catch (error) {}
      }
    },
  },
  methods: {
    uploadBtnClick() {
      try {
        Omega.trackEvent("ibt_global_portrait_takephoto_button_ck", "", {
          ...this.omegaItems,
        });
      } catch (error) {}
    },
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementById("photo");
        imgCompress(photoBtn, this.handleAfterPhoto, this.handleImageError);
      }
    },
    uploadImg() {
      // if (this.field_status == 3) {
      //   this.$refs.toast.show();
      // } else {
      //   this.getPhoto();
      //   // this.isUpload = true;
      // }
      this.getPhoto();
    },
    closeUploadImg() {
      this.isUpload = false;
    },
    getPhoto() {

      if (Fusion && Fusion.chooseImageV2) {
        Fusion.chooseImageV2(
          {
            source: (this.headImgConfig.only_camera || this.headImgConfig.limit_status) ? 2 : 3,
            quailty: 100,
            width: 1500,
            height: 1500,
            scene: 4, // @20231018新的智能审核拍照取景框
            camera_title: this.$t("GDriver_optimization_vEiW_Qiqr"), //拍照上方文案
            page_title: this.$t("GDriver_optimization_qhaw_wHWp"), // 拍照页顶部的标题文案
            track_params: {
              ...this.omegaItems,
            }, //埋点自定义参数
          },
          (ret) => this.handleAfterPhoto(ret)
        );
      } else {
        this.params.get("appversion"); // >= 7.5.92
        const isAndroid = /(Android)/i.test(navigator.userAgent);
        // let isVersionLatest = (version) => {
        //   let versionArray = version.split(".");
        //   return (
        //     +versionArray[0] > 7 ||
        //     (+versionArray[0] === 7 && +versionArray[1] > 5) ||
        //     (+versionArray[0] === 7 &&
        //       +versionArray[1] === 5 &&
        //       +versionArray[2] >= 92)
        //   );
        // };
        // let editable = isAndroid ? isVersionLatest(appVersion) && true : true;

        // const once = (fn) => {
        //   return (...argv) => {
        //     if(fn.called) return fn.res
        //     fn.called = true
        //     return fn.res = fn(...argv)
        //   }
        // }

        // Fusion.chooseImage = ((org) => {
        //   return (...argv) => org(argv[0], once(argv[1]))
        // })(Fusion.chooseImage.bind(Fusion))

        if (isAndroid) {
          Fusion && Fusion.pickImage({ source: -1 }, () => {});
        }
        Fusion.chooseImage(
          {
            source: (this.headImgConfig.only_camera || this.headImgConfig.limit_status) ? 2 : 3,
            quailty: 100,
            width: 1500,
            height: 1500,
            scene: 2, //2头像照, 1证件照
            camera_title: this.$t("GDriver_picture_Line_box_OsdL"), //拍照上方文案
            image_editor_title: this.$t("GDriver_picture_View_frame_usSJ"), // 裁剪上方文案
            is_show_camera_mask: true, // 使用蒙层
            is_hide_camera_local_title: true, // 拍照上方文案使用配置
            is_hidden_image_editor_local_title: true, // 裁剪上方文案使用配置
          },
          (ret) => this.handleAfterPhoto(ret)
        );
      }
    },
    handleAfterPhoto(ret) {
      if (this.inApp) {
        const isAndroid = /(Android)/i.test(navigator.userAgent);
        if (isAndroid) {
          Fusion && Fusion.chooseImage({ source: -1 }, () => {});
        }
      }
      if (!ret.image) {
        return;
      }
      let imgSrc = ret.image;
      if (this.inApp) {
        imgSrc = "data:image/jpeg" + ";base64," + ret.image;
      }
      this.uploadImgSrc = imgSrc;
      const isTakePhoto = ret.source == 2; // 1-相册; 2-拍照

      this.canSubmit = true;

      // if (this.routerParams.configs) {
      //   const localStorageConfig = {
      //     ...this.routerParams,
      //     uploadImgSrc: this.uploadImgSrc,
      //     configs: this.headImgConfig,
      //     isViewAudit: this.isViewAudit,
      //   };
      //   // window.localStorage.setItem(
      //   //   "headlocalStorageConfig",
      //   //   JSON.stringify(localStorageConfig)
      //   // );
      //   window._HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW_ = localStorageConfig
      // }

      let _params = {
        ...this.routerParams,
        uploadImgSrc: this.uploadImgSrc,
        configs: this.headImgConfig,
        isTakePhoto,
      };
      // if (!this.routerParams.configs) {
      //   // const _headlocalStorageConfig =
      //   //   window.localStorage.getItem("headlocalStorageConfig") || "{}";
      //   // const _headlocalStorageConfigParse = JSON.parse(
      //   //   _headlocalStorageConfig
      //   // );
      //   const HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW = window._HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW_ || {}
      //   _params = {
      //     ...HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW,
      //     uploadImgSrc: this.uploadImgSrc,
      //     isTakePhoto,
      //   };
      // }

      this.$router.replace({
        name: "avatarNewBetter",
        params: _params,
      });
    },
    handleImageError() {
      dd.alert({
        desc: this.$t("register---图片尺寸过大"),
      });
    },
    reUploadImg() {
      this.isViewAudit = false;
      this.canSubmit = false;
      this.uploadImgSrc = "";
    },
  },

  computed: {
    inApp() {
      return Fusion ? !!Fusion.chooseImage : false;
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    routerParams() {
      return this.$route.params;
    },
    headImgConfig() {
      // const HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW = window._HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW_ || {}
      // return this.$route.params.configs || HEAD_IMG_ROUTER_CONFIG_AVATAR_NEW.configs || {};
      return this.$route.params.configs || {};
    },
    field_status() {
      return this.headImgConfig.field_status || 0;
    },
    isNew() {
      return (
        this.field_status == 0 ||
        this.field_status == 6 ||
        this.routerParams.isGoBack ||
        !this.$route.params.configs
      );
    },
    pics() {
      return this.headImgConfig.exam_pic_url || [];
    },
    pic_desc() {
      return this.headImgConfig.pic_desc || {};
    },
    error_cases() {
      return this.headImgConfig.error_cases || {};
    },
    uploadBtn() {
      return (
        (this.headImgConfig.upload_button || {}).button_color || {
          un_check: {},
          is_check: {},
        }
      );
    },
    resetBtn() {
      return (
        (this.headImgConfig.reset_button || {}).button_color || {
          un_check: {},
          is_check: {},
        }
      );
    },
    uploadBtnStyle() {
      // 第一次上传
      let btnColor = this.uploadBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border || "none",
      };
    },
    reUploadBtnStyle() {
      // 审核中和审核失败重新上传
      let btnColor = this.resetBtn.is_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border,
      };
    },
    omegaItems() {
      return {
        end: getEnd(),
        channel: this.params.get("channel") || "",
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_cityid: this.params.get("location_cityid") || "",
        location_country: this.params.get("location_country") || "",
        profile_channel:
          this.routerParams.page_source === "personal-info" ? 1 : 0,
        uid: this.routerParams.onboarding_driver_id,
        product: this.routerParams.product,
        is_pc: ends.isPlatformPC
      };
    },
  },
};

export { avatarNew };
